import React from 'react';
import "./Special.css";


function Special() {
  return (
    <div className='spacial-container'>
      <div className="spacial-content">

        <div className='spacial-header'>
          <h3>ÖZEL VE İHTİYACA YÖNELİK KAUÇUK HAMURLARI</h3>
        </div>
        <div className='pro-text-promotion'>
          <h3>ÖZEL VE İHTİYACA YÖNELİK KAUÇUK HAMURLARI</h3>
          <p>
            Uzun yıllara dayanan deneyimimiz, bireysel çözümler sunmamızı sağlamaktadır.
          </p>
          <p>
            Malzeme uzmanlarımız sürekli olarak yeni malzemelerin geliştirilmesi üzerinde çalışmaktadır. Özel müşteri çözümlerinin geliştirilmesi ve verimli hammadde yönetimi bu süreçte en önemli önceliklerimizdir. Malzeme geliştirme sürecinde şirket içi laboratuvarlardan yararlanılır. Araştırma ve geliştirme faaliyetlerinin yanı sıra üretim sürecinde validasyon ve belgelendirme görevleri için son teknoloji makineler, ölçüm ve test ekipmanları kullanılmaktadır. Bu, ürünlerimizi çeşitli uluslararası standartlara göre kalifiye etmemizi sağlar.
          </p>
          <p>
            Ek olarak iş ortaklarımıza ait formülasyonlarla sürdürülebilir tedarik hizmeti sunarak, müşterilerimizin planlı hammadde akışıyla en üst düzey üretim verimliliğine ulaşmalarını sağlamaktayız. Başarımızın anahtarı küresel tedarik zincirimizin gücü ve yerel üretim tesisimizin varlığıdır.
          </p>


        </div>

        <div className='spacial-features'>
          <div className='spacial-features-header'>
            <h3>ÜRÜN ÖZELLİKLERİ</h3>
          </div>
          <p><strong>Elastomer :</strong>NR, BR, SBR, CR, IR, NBR, EPDM, AEM, ACM, NBRPVC bazlı hamurlar</p>
          <p><strong>Sertlik :</strong>35-85 ShA</p>
          <p><strong>Çapraz Bağlama :</strong>Kükürt, peroksit ya da amin pişirici</p>

          <p>normlarına uygun</p>


        </div>



        <div className='info-contact'>
          <button className='btn-contact'>Teklif almak için bizimle iletişime geçebilirsiniz</button>
        </div>

      </div>
    </div>
  )
}

export default Special
